var map = {
	"./coin.svg": "a52c",
	"./death.svg": "6e4f",
	"./eng.svg": "c1fe",
	"./girl.svg": "7c54",
	"./helicopter.svg": "d6ca",
	"./inst.svg": "dfba",
	"./miss.svg": "0527",
	"./mom.svg": "78b2",
	"./palm.svg": "c93e",
	"./pills.svg": "732f",
	"./present.svg": "50d6",
	"./taxi.svg": "33e0",
	"./tv.svg": "f6a2",
	"./ved.svg": "a86c",
	"./viking.svg": "4107",
	"./wash.svg": "2535"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d656";